import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function AdminCommunications() {
  const [wa, setWa] = useState(null);
  useEffect(() => { api.get("/admin/communications/whatsapp").then(({ data }) => setWa(data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-[#080808]" data-testid="admin-communications-page">
      <Seo title="Admin · Communications" description="ERRĀH communications settings" />
      <div className="glass"><div className="max-w-[1000px] mx-auto px-5 h-[60px] flex items-center gap-4">
        <Link to="/admin" className="flex items-center gap-2 text-sm text-gray-300"><ArrowLeft size={16} /> Admin</Link>
      </div></div>
      <div className="max-w-[1000px] mx-auto px-5 py-10">
        <h1 className="serif-head text-3xl lg:text-4xl mb-6">Communications</h1>
        {!wa ? <p className="text-gray-500">Loading…</p> : (
          <div className="hair-border bg-white/[0.02] p-6" data-testid="whatsapp-settings">
            <div className="flex items-center justify-between mb-4">
              <p className="errah-label gold-text flex items-center gap-2"><MessageCircle size={15} /> WhatsApp</p>
              <span className={`text-xs px-3 py-1 border ${wa.status === "CONNECTED" ? "text-emerald-400 border-emerald-500/40" : "text-gray-400 border-white/20"}`} data-testid="wa-provider-status">{wa.status}</span>
            </div>
            <p className="text-sm text-gray-400 mb-1">Provider: <span className="text-gray-200">{wa.provider || "—"}</span></p>
            {wa.message && <p className="text-sm text-yellow-400/80 mb-4">{wa.message}</p>}
            <p className="errah-label mt-6 mb-2">Connected Applicators ({wa.connected_applicators.length})</p>
            <div className="hair-border overflow-hidden">
              {wa.connected_applicators.length === 0 ? <p className="px-4 py-4 text-sm text-gray-600">None yet.</p>
                : wa.connected_applicators.map((a) => (
                  <div key={a.applicator_code} className="flex items-center justify-between px-4 py-2.5 border-b border-white/5 text-sm">
                    <span>{a.name} · {a.applicator_code}</span>
                    <span className="text-gray-400">{a.whatsapp_mobile} {a.whatsapp_verified ? "✓" : ""}</span>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
